<!-- TODO : Is a seperate component needed for this link? Might be an more convinient to move to generic-filter-panel-component -->

<a class="saved-filters-button text-sm p-2 neptune-button-white flex ml-10" (click)="showTheFilterRecallPanel()">
    My Saved Filters <img src="/assets/shared-icons/neptune-icon-blue-chevron-right.svg" alt="chevron-right">
</a>
